import React, { Component } from 'react'

class LoaderDownload extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    return (
      <div className="loader-download-wrapper">
        <div id="loader-download"></div>
        <div className="loader-section-transparent section-left"></div>
        <div className="loader-section-transparent section-right"></div>
      </div>
    )
  }
}

export default LoaderDownload